module.exports = __webpack_public_path__ + "images/feature/20160129_01-276bc50db57c3e6f1b1f105e82fb512b.png";